import React, { ChangeEvent, Component } from 'react';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel, RadioGroup, FormControlLabel, Radio, TextField, Button, Grid } from '@mui/material';
import { GridTable } from '../Sidebar/SidebarStyles';
import { fetchBrokerOptionData, fetchBrokerFileUploadLImit, saveDataForBrokerIdS } from '../ApiSevices/ExdionAdminApi'

interface State {
    brokerOption: any[];
    brokerConfig: any;
    INT_OTP: boolean;
    INT_FILE_SIZE: number;
    checklistEmailOption: 'CSR' | 'CompanyWide';
    DispatchPwd: boolean;
    PdfSend: boolean;
    CompanyEmail: string;
    CCMail: string;
    selectedBroker: string
    loading: boolean;
}
interface Props {
    displaysidebar: boolean
}

class ValidationAndSecurity extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            brokerOption: [],
            brokerConfig: null,
            INT_OTP: false,
            INT_FILE_SIZE: 0,
            checklistEmailOption: 'CSR',
            DispatchPwd: false,
            PdfSend: false,
            CompanyEmail: "",
            CCMail: "",
            selectedBroker: "",
            loading: false
        };
    };

    componentDidMount() {
        this.fetchBrokerData();
    }

    fetchBrokerData = async (brokerId?: string | number) => {
        this.setState({ loading: true });

        try {
            const fetchResponse = await fetchBrokerOptionData(brokerId);
            if (fetchResponse && fetchResponse?.length > 0) {
                this.setState({ brokerOption: fetchResponse });
            }

        } catch (error) {
            console.error('Error fetching brokerData:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchBrokerConfig = async (selectedBroker: any) => {
        this.setState({ loading: true });

        try {
            const brokerConfig = await fetchBrokerFileUploadLImit(selectedBroker); 
            const checklistEmailOption = brokerConfig?.CompanyEmail ? 'CompanyWide' : 'CSR';

            this.setState({
                brokerConfig,
                INT_FILE_SIZE: brokerConfig.INT_FILE_SIZE || 0,
                INT_OTP: brokerConfig.INT_OTP === 1,
                checklistEmailOption,
                CompanyEmail: brokerConfig.CompanyEmail || '',
                CCMail: brokerConfig.CCMail || '',
                DispatchPwd: brokerConfig.DispatchPwd === 1,
                PdfSend: brokerConfig.PdfSend === 1,
            });
        } catch (error) {
            console.error('Error fetching brokerConfigData:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleChecklistEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ checklistEmailOption: event.target.value as 'CSR' | 'CompanyWide' })
    };

    handleCompanyEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ CompanyEmail: event.target.value })
    };

    handleNumericInput = (event: any) => {
        const charCode = event.which ? event.which : event.keyCode;

        if (
            charCode === 8 || // Backspace
            charCode === 9 || // Tab
            charCode === 46 || // Delete
            (charCode >= 37 && charCode <= 40) // Arrow keys
        ) {
            return;
        }

        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    handleSaveRow = async () => {
        this.setState({ loading: true});
        const {
            selectedBroker,
            INT_FILE_SIZE,
            INT_OTP,
            CompanyEmail,
            CCMail,
            DispatchPwd,
            PdfSend
        } = this.state;

        const selectedRow = {
            INT_OTP: INT_OTP ? 1 : 0,
            INT_FILE_SIZE: INT_FILE_SIZE || 0,
            BrokerID: selectedBroker || 0,
            CompanyEmail: CompanyEmail || "",
            CCMail: CCMail || "",
            DispatchPwd: DispatchPwd ? 1 : 0,
            PdfSend: PdfSend ? 1 : 0
        };

        try {
            const saveResData = await saveDataForBrokerIdS(selectedRow);
            if (saveResData) {
                console.log("Save successful", saveResData);

                this.setState({
                    INT_OTP: false,
                    INT_FILE_SIZE: 0,
                    checklistEmailOption: 'CSR',
                    DispatchPwd: false,
                    PdfSend: false,
                    CompanyEmail: "",
                    CCMail: "",
                    selectedBroker: "",
                });
            }
        } catch (error) {
            console.error("Error saving broker config:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    renderRow = (
        label: string,
        component: React.ReactNode,
        key?: string
    ) => (
        <Grid
            container
            spacing={1}
            alignItems="center"
            sx={{
                mb: 1,
                fontSize: { xs: '12px', sm: '12px', md: '12px' },
            }}
            key={key}
        >
            <Grid item xs={12} sm={4} md={3}>
                <Typography
                    sx={{
                        fontSize: { xs: '12px', sm: '12px', md: '12px' },
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={9}>
                {component}
            </Grid>
        </Grid>
    );

    render() {
        const { displaysidebar } = this.props;
        const { checklistEmailOption, selectedBroker, loading, brokerOption } = this.state;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable displaysidebar={displaysidebar}>
                    <Box sx={{ padding: '2px 0', backgroundColor: '#f8f8f8', borderBottom: '1px solid #ddd', marginBottom: '25px    ' }}>
                        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#000', marginLeft: '8px', textTransform: 'uppercase' }}>
                            VALIDATION AND SECURITY </span>
                    </Box>

                    <Box sx={{ p: 2, width: '100%', maxWidth: { xs: '100%', sm: '700px', md: '900px' }, backgroundColor: '#fff', border: '2px solid #ddd' }}>

                        {this.renderRow(
                            'Select Broker',
                            <FormControl fullWidth size='small'>
                                <Select value={selectedBroker}
                                    displayEmpty
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        this.setState({ selectedBroker: selected });
                                        this.fetchBrokerConfig(selected);
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span style={{ color: '#88888863', fontSize: '12px' }}>Select Broker</span>;
                                        }
                                        const selectedBrokerObj = brokerOption?.find((b: any) => b?.Broker_ID === selected);
                                        return <span style={{ fontSize: '12px' }}>{selectedBrokerObj?.vchBrokerName || selected}</span>;
                                    }}
                                    sx={{
                                        fontSize: { xs: '12px', sm: '12px' },
                                        height: { xs: 36, sm: 32 },
                                    }}>
                                    <MenuItem value="" disabled sx={{ fontSize: '12px' }}>Select Broker</MenuItem>
                                    {brokerOption?.map((broker: any) => (
                                        <MenuItem
                                            key={broker.Broker_ID}
                                            value={broker.Broker_ID}
                                            sx={{ fontSize: '12px' }}
                                        >
                                            {broker?.vchBrokerName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}

                        {this.renderRow(
                            'OTP Enable',
                            <RadioGroup row>
                                <FormControlLabel value="Always" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>Always</Typography>} />
                                <FormControlLabel value="Never" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>Never</Typography>} />
                            </RadioGroup>
                        )}

                        {this.renderRow(
                            'File Upload Size',
                            <TextField fullWidth size="small" value={this.state?.INT_FILE_SIZE} onChange={(e) => this.setState({ INT_FILE_SIZE: Number(e.target.value) })} onKeyDown={this.handleNumericInput} sx={{
                                fontSize: '12px',
                                input: {
                                    fontSize: '12px',
                                    height: { xs: 36, sm: 32 },
                                    padding: '0px 6px',
                                },
                            }} />
                        )}

                        {this.renderRow(
                            'Checklist To Email',
                            <RadioGroup row value={this.state?.checklistEmailOption} onChange={this.handleChecklistEmailChange}>
                                <FormControlLabel value="CSR" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>CSR</Typography>} />
                                <FormControlLabel value="CompanyWide" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={< Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>Company Wide</Typography>} />
                            </RadioGroup>
                        )}

                        {checklistEmailOption === 'CompanyWide' &&
                            this.renderRow(
                                'Company Email',
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={this.state?.CompanyEmail}
                                    onChange={this.handleCompanyEmailChange}
                                    sx={{
                                        fontSize: '12px',
                                        input: {
                                            fontSize: '12px',
                                            height: { xs: 36, sm: 32 },
                                            padding: '0px 6px',
                                        },
                                    }}
                                />
                            )}

                        {this.renderRow(
                            'Checklist CC Email',
                            <TextField fullWidth size="small" value={this.state?.CCMail} onChange={(e) => this.setState({ CCMail: e.target.value })}
                                sx={{
                                    fontSize: '12px',
                                    input: {
                                        fontSize: '12px',
                                        height: { xs: 36, sm: 32 },
                                        padding: '0px 6px',
                                    },
                                }} />
                        )}

                        {this.renderRow(
                            'Is Dispatch Checklist  Protect ?',
                            <RadioGroup
                                row
                                value={this.state?.DispatchPwd ? 'Yes' : 'No'}
                                onChange={(e) => this.setState({ DispatchPwd: e.target.value === 'Yes' })}
                            >
                                <FormControlLabel value="No" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>No</Typography>} />
                                <FormControlLabel value="Yes" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>Yes</Typography>} />
                            </RadioGroup>
                        )}

                        {this.renderRow(
                            'Is PDF file to be send ?',
                            <RadioGroup
                                row
                                value={this.state?.PdfSend ? 'Yes' : 'No'}
                                onChange={(e) => this.setState({ PdfSend: e.target.value === 'Yes' })}
                            >
                                <FormControlLabel value="No" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>No</Typography>} />
                                <FormControlLabel value="Yes" control={<Radio sx={{ paddingLeft: '10px' }} size="small" />} label={<Typography sx={{ fontSize: '12px', marginLeft: '-7px' }}>Yes</Typography>} />
                            </RadioGroup>
                        )}

                        {this.renderRow(
                            'Sampling',
                            <TextField fullWidth size="small" defaultValue="0" sx={{
                                fontSize: '12px',
                                input: {
                                    fontSize: '12px',
                                    height: { xs: 36, sm: 32 },
                                    padding: '0px 6px',
                                },
                            }} />
                        )}

                        <Box sx={{ textAlign: 'right' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#1e1466',
                                    fontSize: '11px',
                                    padding: '2px 12px',
                                    minWidth: 60,
                                    height: 28,
                                    mt: 2,
                                    textTransform: 'none'
                                }}
                                onClick={this.handleSaveRow}
                            >
                                Save
                            </Button>
                        </Box>
                    </Box>
                </GridTable>
            </>
        )
    }
};

export default ValidationAndSecurity;